import React, { useState, useEffect } from "react";
import axios from "axios";

import Layout from "../../layouts";
import Header from "../../layouts/header";
import Footer from "../../layouts/footer";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";

import { showToast } from "../../utils/toast.js";
import { buttonStyles } from "../../stylesGenerales/buttons.js";

import TemaCapacitacionForm from "./TemaCapacitacionForm";
import ConfirmModalTema from "./ConfirmModalTema";
import TemasCapacitacionTable from "./TemasCapacitacionTable";

const API = process.env.REACT_APP_API_URL;
const token = sessionStorage.getItem("token");

const TemaCapacitacionContainer = () => {

    const [nombreTema, setNombreTema] = useState("");

    const [temas, setTemas] = useState([]);

    const [editingId, setEditingId] = useState(null);

    const [temaActivoEditando, setTemaActivoEditando] = useState(true);

    const [mostrarFormulario, setMostrarFormulario] = useState(false);

    const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);

    const [temaSeleccionado, setTemaSeleccionado] = useState(null);

    const [busqueda, setBusqueda] = useState("");

    const [paginaActual, setPaginaActual] = useState(1);

    const [elementosPorPagina, setElementosPorPagina] = useState(5);

    useEffect(() => {
        fetchTemas();
    }, []);

    const fetchTemas = async () => {

        try {

            const res = await axios.get(
                `${API}/temas-capacitacion/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const data = Array.isArray(res.data)
                ? res.data
                : Array.isArray(res.data.results)
                    ? res.data.results
                    : [];

            setTemas(data);

        } catch (error) {

            console.error(error);

            showToast(
                "Error al cargar los temas",
                "error"
            );
        }
    };

    const handleSubmit = async e => {

        e.preventDefault();

        try {

            const yaExiste = temas.some(
                t =>
                    t.nombretema?.trim().toLowerCase() ===
                    nombreTema.trim().toLowerCase()
                    &&
                    t.idtemacapacitacion !== editingId
            );

            if (yaExiste) {

                showToast(
                    "Ya existe un tema con ese nombre",
                    "warning"
                );

                return;
            }

            const idUsuario = Number(
                sessionStorage.getItem("idUsuario")
            );

            const payload = {

                nombretema: nombreTema,

                descripcion: nombreTema,

                estado: Boolean(temaActivoEditando),

                idusuario: idUsuario
            };

            if (editingId) {

                await axios.put(
                    `${API}/temas-capacitacion/editar/${editingId}/`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

            } else {

                await axios.post(
                    `${API}/temas-capacitacion/crear/`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
            }

            showToast(
                editingId
                    ? "Tema actualizado correctamente"
                    : "Tema registrado correctamente"
            );

            setNombreTema("");

            setEditingId(null);

            setTemaActivoEditando(true);

            setMostrarFormulario(false);

            fetchTemas();

        } catch (error) {

            console.error(error);

            showToast(
                "Error al guardar tema",
                "error"
            );
        }
    };

    const handleEdit = tema => {

        if (!tema.estado) {

            showToast(
                "No se puede editar un tema inactivo",
                "warning"
            );

            return;
        }

        setNombreTema(tema.nombretema);

        setEditingId(tema.idtemacapacitacion);

        setTemaActivoEditando(tema.estado);

        setMostrarFormulario(true);
    };

    const handleDelete = tema => {

        setTemaSeleccionado(tema);

        setMostrarConfirmacion(true);
    };

    const confirmarDesactivacionTema = async () => {

        if (!temaSeleccionado) return;

        try {

            const idUsuario = Number(
                sessionStorage.getItem("idUsuario")
            );

            await axios.put(
                `${API}/temas-capacitacion/editar/${temaSeleccionado.idtemacapacitacion}/`,
                {
                    nombretema: temaSeleccionado.nombretema,
                    descripcion: temaSeleccionado.nombretema,
                    estado: false,
                    idusuario: idUsuario
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            showToast(
                "Tema desactivado correctamente"
            );

            fetchTemas();

        } catch (error) {

            console.error(error);

            showToast(
                "Error al desactivar tema",
                "error"
            );

        } finally {

            setMostrarConfirmacion(false);

            setTemaSeleccionado(null);
        }
    };

    const handleActivate = async id => {

        try {

            const tema = temas.find(
                t => t.idtemacapacitacion === id
            );

            if (!tema) return;

            const idUsuario = Number(
                sessionStorage.getItem("idUsuario")
            );

            await axios.put(
                `${API}/temas-capacitacion/editar/${id}/`,
                {
                    nombretema: tema.nombretema,
                    descripcion: tema.nombretema,
                    estado: true,
                    idusuario: idUsuario
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            showToast(
                "Tema activado correctamente"
            );

            fetchTemas();

        } catch (error) {

            console.error(error);

            showToast(
                "Error al activar tema",
                "error"
            );
        }
    };

    const temasFiltrados = temas

        .sort((a, b) => {

            const nombreA =
                (a.nombretema || "").toLowerCase();

            const nombreB =
                (b.nombretema || "").toLowerCase();

            return nombreA.localeCompare(nombreB);
        })

        .filter(t => {

            const texto =
                busqueda.toLowerCase().trim();

            const nombreCoincide =
                t.nombretema?.toLowerCase().includes(texto)
                || false;

            const estadoCoincide =
                (t.estado ? "activo" : "inactivo")
                    .startsWith(texto);

            return nombreCoincide || estadoCoincide;
        });

    const indexOfLast =
        paginaActual * elementosPorPagina;

    const indexOfFirst =
        indexOfLast - elementosPorPagina;

    const temasPaginados =
        temasFiltrados.slice(
            indexOfFirst,
            indexOfLast
        );

    const totalPaginas = Math.ceil(
        temasFiltrados.length / elementosPorPagina
    );

    return (

        <Layout>

            <SEO title="Temas de Capacitación" />

            <div
                style={{
                    display: "flex",
                    minHeight: "100vh"
                }}
            >

                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >

                    <Header />

                    <main
                        className="main-content site-wrapper-reveal"
                        style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#EEF2F7",
                            padding: "48px 20px 8rem"
                        }}
                    >

                        <div
                            style={{
                                width: "min(1100px, 96vw)"
                            }}
                        >

                            <h2
                                style={{
                                    marginBottom: "20px",
                                    textAlign: "center"
                                }}
                            >
                                Temas de Capacitación
                            </h2>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "15px",
                                    alignItems: "center"
                                }}
                            >

                                <input
                                    type="text"
                                    placeholder="Buscar tema..."
                                    value={busqueda}
                                    onChange={e => {
                                        setBusqueda(e.target.value);
                                        setPaginaActual(1);
                                    }}
                                    style={buttonStyles.buscador}
                                />

                                <button
                                    onClick={() =>
                                        setMostrarFormulario(true)
                                    }
                                    style={buttonStyles.nuevo}
                                >
                                    Nuevo Tema
                                </button>
                            </div>

                            <TemasCapacitacionTable
                                temas={temasPaginados}
                                handleEdit={handleEdit}
                                handleDelete={handleDelete}
                                handleActivate={handleActivate}
                                paginaActual={paginaActual}
                                totalPaginas={totalPaginas}
                                setPaginaActual={setPaginaActual}
                            />

                            <div
                                style={{
                                    marginTop: "20px",
                                    textAlign: "center"
                                }}
                            >

                                <label
                                    style={{
                                        marginRight: "10px",
                                        fontWeight: "600"
                                    }}
                                >
                                    Mostrar:
                                </label>

                                <input
                                    type="number"
                                    min="1"
                                    value={elementosPorPagina}
                                    onChange={e => {

                                        const val =
                                            e.target.value.replace(/\D/g, "");

                                        const numero =
                                            val === ""
                                                ? ""
                                                : Number(val);

                                        setElementosPorPagina(
                                            numero > 0
                                                ? numero
                                                : 1
                                        );

                                        setPaginaActual(1);
                                    }}
                                    onFocus={e => e.target.select()}
                                    style={{
                                        width: "80px",
                                        padding: "6px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                        textAlign: "center"
                                    }}
                                />

                            </div>

                        </div>

                    </main>

                    <Footer />

                </div>

                {mostrarFormulario && (

                    <TemaCapacitacionForm

                        nombreTema={nombreTema}

                        setNombreTema={setNombreTema}

                        temaActivoEditando={temaActivoEditando}

                        editingId={editingId}

                        handleSubmit={handleSubmit}

                        onClose={() =>
                            setMostrarFormulario(false)
                        }
                    />
                )}

                {mostrarConfirmacion && (

                    <ConfirmModalTema

                        tema={temaSeleccionado}

                        modo={
                            temaSeleccionado?.estado
                                ? "desactivar"
                                : "activar"
                        }

                        onConfirm={() => {

                            if (temaSeleccionado?.estado) {

                                confirmarDesactivacionTema();

                            } else {

                                handleActivate(
                                    temaSeleccionado.idtemacapacitacion
                                );

                                setMostrarConfirmacion(false);

                                setTemaSeleccionado(null);
                            }
                        }}

                        onCancel={() =>
                            setMostrarConfirmacion(false)
                        }
                    />
                )}

                <ScrollToTop />

            </div>

        </Layout>
    );
};

export default TemaCapacitacionContainer;